import { STORAGE_URL } from "../constants";

export const quoteProjectBackground =
  "https://ishrostorage.blob.core.windows.net/container-3d/Rectangle%20251.png";
export const apeCoinLogo =
  "https://ishrostorage.blob.core.windows.net/container-3d/Powered%20By%20Ape%20Coin%20White.png";
export const madeByApeLogo =
  "https://ishrostorage.blob.core.windows.net/container-3d/BY%20APES%20LICENSE%2069%20White%201.png";

export const madeByUnityLogo =
  "https://ishrostorage.blob.core.windows.net/container-3d/unity_logo.png";
export const homeBanner =
  "https://ishrostorage.blob.core.windows.net/container-3d/MAYC%20banner.png";

export const homeFooterInceptive =
  "https://ishrostorage.blob.core.windows.net/container-3d/MAYC%20banner.png";
export const apeCoinOnlyLogo =
  "https://ishrostorage.blob.core.windows.net/container-3d/apeCoinLogo.png";
export const Logo = STORAGE_URL + "bayc-3d/logo.png";

export const popupBg = STORAGE_URL + "bayc-3d/chain.png";
export const curvedText = STORAGE_URL + "bayc-3d/curveText.png";
export const closeIcon = STORAGE_URL + "bayc-3d/close.png";


